export default __webpack_public_path__ + "static/media/kotlin.3ff4ea6d.svg";